// stores/playerStore.js
import {defineStore} from 'pinia';

export const usePlayerStore = defineStore('user', {
    state: () => ({
        userData: JSON.parse(localStorage.getItem('user')) || null
    }),
    actions: {
        setUser(data) {
            this.userData = data;
            localStorage.setItem('user', JSON.stringify(data));
        },
        clearUser() {
            this.userData = null;
            localStorage.removeItem('user');
        }
    }
});
